import { QueryClient } from '@tanstack/react-query';

import { IMyCertificatesTableRow } from '../interfaces/ICertificate';

// Dedicated query key for certificates that are still being uploaded. It is intentionally NOT a
// prefix of ['certificate'] so that invalidating the real list never touches it.
export const OPTIMISTIC_MY_CERTIFICATES_QUERY_KEY = ['my-certificates-optimistic'];

// A certificate whose POST is still in flight. It has no `id` yet (so the table treats it as
// non-clickable) and no validity or status, because those are the columns the server decides —
// the table skeletons them. `optimisticKey` only has to identify the row for removal once the
// request settles; unlike the permission placeholders there is nothing external to match it to.
export type OptimisticMyCertificate = Omit<
  IMyCertificatesTableRow,
  'id' | 'validUntil' | 'status'
> & {
  id?: undefined;
  optimisticKey: string;
};

export const getOptimisticMyCertificateKey = (): string => {
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const addOptimisticMyCertificate = (
  queryClient: QueryClient,
  row: OptimisticMyCertificate,
): void => {
  queryClient.setQueryData<OptimisticMyCertificate[]>(
    OPTIMISTIC_MY_CERTIFICATES_QUERY_KEY,
    (prev) => {
      return [row, ...(prev ?? [])];
    },
  );
};

export const removeOptimisticMyCertificate = (
  queryClient: QueryClient,
  optimisticKey: string,
): void => {
  queryClient.setQueryData<OptimisticMyCertificate[]>(
    OPTIMISTIC_MY_CERTIFICATES_QUERY_KEY,
    (prev) => {
      return (prev ?? []).filter((row) => {
        return row.optimisticKey !== optimisticKey;
      });
    },
  );
};
